import { createClient } from "@sanity/sveltekit";
import { PUBLIC_SANITY_DATASET, PUBLIC_SANITY_STUDIO_URL } from "$app/env/public";

export const client = createClient({
	projectId: "n5xeg4df",
	dataset: PUBLIC_SANITY_DATASET || "ishavskraft-001",
	apiVersion: "2024-03-15",
	useCdn: true,
	stega: {
		enabled: true,
		studioUrl: PUBLIC_SANITY_STUDIO_URL || "https://ishavskraft.sanity.studio",
	},
});
